import { useEffect } from "react";

import routes from "@/constants/routes";
import { defaultLanguage } from "@/i18n";
import { useNavigate } from "react-router-dom";

import { useAuth } from "../auth/useAuth";

const LoginRedirectPage = () => {
  const { login, isAuthenticated, authLoading } = useAuth();
  const navigate = useNavigate();
  const language = () => {
    return localStorage.getItem("i18nextLng") || defaultLanguage;
  };

  useEffect(() => {
    if (authLoading) {
      return;
    }
    if (!isAuthenticated()) {
      login();
    } else {
      navigate(routes.root.replace(":lang?", language));
    }
  }, [login, isAuthenticated, authLoading]);

  return (
    <div className="flex min-h-screen min-w-80 flex-col items-center justify-center bg-backgroundApp">
      Redirecting...
    </div>
  );
};

export { LoginRedirectPage };
